import { api } from '../api'

/**
 * Jobs data layer
 * 
 * Provides methods to read and manipulate tools data
 * Depends on an API module that provides HTTP methods
 * 
 * @param {object} api - API module to interact with the server
 * @param object.get - GET method
 * @param object.post - POST method
 */
const TLRAPI = () => {
    return {
        getAllUploads,
        uploadtlrdata,
        deleteUpload,

    }


    async function getAllUploads(limit, offset, ordering) {
        const uploads = await api.get(`api/tlr/dataupdation?limit=${limit}&offset=${offset}&ordering=${ordering}`)
        const { results, count } = uploads
        return {
            uploads: results.map(j => ({ ...j, key: j.id })),
            count
        }
    }
    /**
     * Create a new upload
     */
    async function uploadtlrdata(tlrdata) {
        const url = "api/tlr/dataupdation"

        const {
            type,
            input_file,
            csrf_token,
        } = tlrdata
        const data = new FormData()


        data.append('input_file', input_file.originFileObj)
        data.append('type', type)
        if (csrf_token) {
            data.append("csrf_token", `ajax:${csrf_token}`)
        }
        return await api.post(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    }

    /**
     * Delete a cookie
     */
    async function deleteUpload(uploadId) {
        const url = `api/tlr/dataupdation/${uploadId}`

        return await api.delete(url)
    }


}


export default TLRAPI